import { MutationTree } from 'vuex'
import { AuthState } from '@/store/modules/auth/state'
import {
  Types,
  StoreAuthUser,
  StoreAuthPointUpdate,
  StoreAuthEmailVerified,
} from '@/store/modules/auth/types'
import { Gender } from '@/core/Programs'

export const mutations: MutationTree<AuthState> = {
  [Types.STORE_AUTH_USER]: (state, { payload }: StoreAuthUser) => {
    state.id = payload.id
    state.email = payload.email
    state.emailVerifiedAt = payload.emailVerifiedAt
    state.point = payload.point
    state.name = payload.name
    state.sex = payload.sex
    state.passwordWarning = payload.passwordWarning ?? false
    state.nickname = payload.nickname
    state.romanName = payload.romanName
    state.imagePath = payload.imagePath
    state.isExemptedFromDowngrade = payload.isExemptedFromDowngrade
    state.canPurchaseShortage = payload.canPurchaseShortage
    state.transactionFee = payload.transactionFee ?? null
    state.isCorporateMember = payload.isCorporateMember
    state.pointSubscription = payload.pointSubscription
    state.progress = payload.progress
    state.canceledPointSubscriptionNum = payload.canceledPointSubscriptionNum
    state.age = payload.age
    state.prefecture = payload.prefecture
    state.postalCode = payload.postalCode
  },

  [Types.STORE_AUTH_LOGOUT]: (state) => {
    state.id = 0
    state.email = ''
    state.emailVerifiedAt = null
    state.name = 'ゲスト'
    state.point = 0
    state.sex = Gender.NONE
    state.passwordWarning = false
    state.nickname = ''
    state.romanName = ''
    state.imagePath = null
    state.isExemptedFromDowngrade = false
    state.canPurchaseShortage = false
    state.transactionFee = null
    state.isCorporateMember = false
    state.pointSubscription = null
    state.progress = null
    state.canceledPointSubscriptionNum = 0
    state.age = null
    state.prefecture = null
    state.postalCode = null
  },

  [Types.STORE_AUTH_UPDATE_POINT]: (state, action: StoreAuthPointUpdate) => {
    state.point = action.payload.point
  },

  [Types.STORE_AUTH_EMAIL_VERIFIED]: (
    state,
    action: StoreAuthEmailVerified
  ) => {
    state.emailVerifiedAt = action.payload.emailVerifiedAt
  },
}
